/**
 * @file bytescale.api.js
 * @module BytescaleAPI
 * @description HTTP API wrapper for Bytescale file-processing endpoints. Methods return Axios promises.
 */

import axios from "axios"
import { BYTESCALE_API_URL, BYTESCALE_ACCOUNT_ID, BYTESCALE_API_SECRET_KEY, BYTESCALE_API_PUBLIC_KEY } from "../config/env";

export const BytescaleAPI = {
    /**
     * Delete a file by its file path from Bytescale account.
     * @param {string} filePath - Path of the file to delete.
     * @returns {Promise} Axios promise resolving to deletion result.
     */
    deleteFileByFilePath: (filePath) => {
        return axios.delete(`${BYTESCALE_API_URL}/v2/accounts/${BYTESCALE_ACCOUNT_ID}/files`, { params: { filePath: filePath }, headers: { Authorization: `Bearer ${BYTESCALE_API_SECRET_KEY}` } });
    },

    /**
     * List files within a folder path in Bytescale account.
     * @param {string} folderPath - Path of the folder to list.
     * @returns {Promise} Axios promise resolving to files list.
     */
    getFilesByFilePath: (folderPath) => {
        return axios.get(`${BYTESCALE_API_URL}/v2/accounts/${BYTESCALE_ACCOUNT_ID}/folders/list`, { params: { folderPath: folderPath }, headers: { Authorization: `Bearer ${BYTESCALE_API_SECRET_KEY}` } });
    }
}
